<template>
  <div v-if="submission" class="submission-panel__wrapper">
    <SubmissionNotification
      v-if="showNotification"
      :affiliate="submittedAffiliate"
    />
    <SubmissionPanel :submission="submission" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import SubmissionNotification from "@/modules/supporters/components/submission/submission-notification.vue";
import SubmissionPanel from "@/modules/supporters/components/submission/submission-panel.vue";

import { ICompany } from "@/modules/profile/services/data/company/company.types";
import { AffiliateState } from "@/modules/supporters/services/store/affiliate/affiliate.module";
import { ISupporter } from "@/modules/matching/services/data/matching-score/supporter.interface";
import { IAffiliateProgramSupporterSubmission } from "@/modules/supporters/services/data/affiliate-program-supporter-submission/affiliate-program-supporter-submission.interface";
import { IAffiliate } from "@/services/data/affiliate/affiliate.interface";

export default defineComponent({
  components: {
    SubmissionNotification,
    SubmissionPanel,
  },

  props: {
    submission: {
      type: Object as () => null | IAffiliateProgramSupporterSubmission,
      default: null,
    },

    showNotification: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    isLoading(): boolean {
      return [!this.profileCompany, !this.profileSupporter].some(
        (stillLoading) => stillLoading,
      );
    },

    submittedAffiliate(): IAffiliate {
      return this.$store.getters[AffiliateState.Getter.VALUE] || null;
    },

    profileSupporter(): ISupporter | null {
      return this.submission?.supporter || null;
    },

    profileCompany(): ICompany | null {
      return this.submission?.supporter.user_profile.company || null;
    },

    profileCompanyId(): number | null {
      return this.profileCompany ? this.profileCompany.id : null;
    },
  },
});
</script>

<style lang="scss" scoped>
.submission-panel__wrapper :deep() .submission-panel__notice {
  margin-bottom: 26px;
}

.submission-panel__wrapper.px-loading-parent--relative {
  @include breakpoint-up(md) {
    min-height: calc(100vh - 200px);
  }
}
</style>
